<script>
import Nav from "@/components/Nav/index.vue";
import { nextTick } from "vue";
import axios from "axios";
export default {
    name: "Coupon",
    data() {
        return {
            tab: "available",
            my_gift_coupon: [],
        };
    },
    components: {
        Nav,
    },
    computed: {
        userNbInfo() {
            return this.$store.state.userNbInfo;
        },
        hostUrl() {
            return this.$store.state.hostUrl;
        },
        availableCoupons() {
            const now = new Date();
            return this.my_gift_coupon
                .filter(c => !c.use_end_at || new Date(c.use_end_at) >= now)
                .sort((a, b) => (a.status == '已使用' ? 1 : 0) - (b.status == '已使用' ? 1 : 0));
        },
        expiredCoupons() {
            const now = new Date();
            return this.my_gift_coupon.filter(c =>
                c.use_end_at && new Date(c.use_end_at) < now
            );
        },
    },
    mounted() {
        const _this = this;
        nextTick(() => {});
        _this.$store.commit("loadingToggle", true);
        axios.get(`${_this.hostUrl}member/my_gift_coupon`, {
            headers: {
                Authorization: `Bearer ${_this.$store.state.userNbInfo.access_token}`,
            }
        }).then(response => {
            _this.my_gift_coupon = response.data.data.my_gifts;
            console.log(_this.my_gift_coupon)
            nextTick(() => {
                _this.$store.commit("loadingToggle", false);
            });
        }).catch(error => {
            console.error(error);
            _this.$store.commit("loadingToggle", false);
        });
    },
    methods: {
        formatDate(str) {
            return str ? str.split(' ')[0].replace(/-/g, '/') : '';
        },
        goDetail(item) {
            this.$store.commit('setSelectedCouponItem', item);
            this.$router.push({
                name: 'CouponDetail',
                params: { id: item.coupon_no },
            });
        },
    },
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped></style>
